import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { MobileSidebar } from './MobileSidebar';
import { MobileTabBar } from './MobileTabBar';
import { Header } from './Header';
import { useAuthStore } from '../../store/authStore';
import { useThemeStore } from '../../store/themeStore';
import { useIsMobile } from '../../hooks/useIsMobile';

export const MainLayout: React.FC = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const theme = useThemeStore((state) => state.theme);
  const isMobile = useIsMobile();
  const [sidebarWidth, setSidebarWidth] = React.useState(280);

  // Force theme re-application when entering authenticated routes
  React.useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('light', 'dark');

    if (theme === 'system') {
      const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light';
      root.classList.add(systemTheme);
    } else {
      root.classList.add(theme);
    }
  }, [theme]);

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex h-screen overflow-hidden bg-white dark:bg-gray-900">
      {/* Mobile Sidebar - Dialog overlay, also used as "More" menu from tab bar */}
      <MobileSidebar />

      {/* Desktop Sidebar - hidden on mobile */}
      {!isMobile && (
        <div className="hidden lg:block">
          <Sidebar width={sidebarWidth} onWidthChange={setSidebarWidth} />
        </div>
      )}

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        <Header isMobile={isMobile} />
        <main className={`flex-1 overflow-y-auto bg-gray-50 dark:bg-gray-900 overscroll-contain ${isMobile ? 'pb-[72px]' : ''}`}>
          <div className="h-full">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Mobile Bottom Tab Bar */}
      {isMobile && <MobileTabBar />}
    </div>
  );
};
